import { getResourceDriver } from "./registry";
import type { ResourceDefinition, ResourceRuntimeContext } from "./types";

export const getResourceDefinitions = (context: ResourceRuntimeContext): ResourceDefinition[] =>
  context.definition.workflow.flatMap((step) =>
    step.blocks.flatMap((block) =>
      ("resources" in block ? block.resources : []).flatMap((declaration) =>
        getResourceDriver(declaration).define(
          context,
          {
            stepId: step.key,
            label: step.label,
            conditions: [step.showWhen, block.showWhen].filter((condition) => condition !== undefined),
          },
          declaration,
        ),
      ),
    ),
  );
